// Field-support search branding comes from the user's division, not a selected dealer.
export const getFieldSupportBrand = (divisionCode) =>
  divisionCode?.trim().toUpperCase() === "LIN" ? "L" : "F";
